import React, {useState} from 'react'
import Loading from '../Components/MinComponents/Loading';
import SingleProductTab from '../Components/MinComponents/SingleProductTab';
import { useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
const Products = () => {
    const [products,setProducts]=useState([]);
    const [isLoading,setLoading]=useState(true);
    const {category}=useParams();
    useEffect(()=>{
        var url=`${process.env.REACT_APP_BASE}/products`
        axios.get(url)
        .then(res=>{
            setProducts(res.data.products);
            setLoading(false);
        })
        .catch(err=>{
            console.log(err)
        });
    },[]);


  return (
      <div className="bg-white">
          <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
            {
              category==undefined ? <h2 className="text-lg font-bold">PRODUCTS</h2> : <h2 className="text-lg font-bold">{category.toUpperCase()} PRODUCTS</h2>
            }
            {            
            isLoading?
            <Loading/>:
                products.length===0?
                <div>
                    No Products to show. Please Come Again Later
                </div>
                :!category?
                <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
                  {products.map(item=>{
                    return <SingleProductTab data={item}/>
                  })}
                </div>:
                  products.filter(item=>item.category===category).length>0?
                  <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
                    {
                      products.filter(item=>item.category===category).map(item=>{
                      return <SingleProductTab data={item}/>
                      })
                    }
                  </div>
                  :
                  <div className='w-100 m-auto'>
                    No Products to show. <br></br> Please Come Again Later
                  </div>
            }
              
          </div>
      </div>
  )
}

export default Products